import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TrafficSigns } from '@powdr/constants';
import { getTraffic } from '@powdr/stores';

export const useTrafficSignStatus = (trafficSign) => {
  if (!trafficSign) return null;

  const dispatch = useDispatch();
  const useTrafficData = useSelector((state) => state.traffic);
  const { data } = useTrafficData;
  const [trafficStatus, setTrafficStatus] = useState(null);

  useEffect(() => {
    dispatch(getTraffic());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      setTrafficStatus(data?.[TrafficSigns?.[process.env.GATSBY_PROPERTY_NAME]?.[trafficSign]]);
    }
  }, [data, trafficSign]);

  return trafficStatus;
};
